import React from 'react';
import { UserPlus, MessageCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";

export default function InviteButton({ variant = "default" }) {
  const handleInvite = () => {
    const inviteText = `¡Hola! Te invito a usar ScanEat, una app que te ayuda a comer más inteligente analizando las etiquetas de productos. ¡Descúbrela! ${window.location.origin}`;
    const url = `https://wa.me/?text=${encodeURIComponent(inviteText)}`;
    window.open(url, '_blank');
  };

  if (variant === "compact") {
    return (
      <Button onClick={handleInvite} size="sm" variant="outline" className="flex items-center gap-1.5 px-2 h-8">
        <MessageCircle className="w-3.5 h-3.5 text-green-600 flex-shrink-0" />
        <span className="hidden sm:inline text-xs">Invitar</span>
      </Button>
    );
  }

  return (
    <Button onClick={handleInvite} className="flex items-center gap-2 bg-green-600 hover:bg-green-700">
      <UserPlus className="w-4 h-4" />
      Invitar por WhatsApp
    </Button>
  );
}